import React from 'react'
import classNames from 'classnames'

const BackgroundRenderer = ({ value, color = 'label' }) => {

  return (
    <div
      className={classNames(
        'viso-grid-list-background',
        `viso-text-${color}`,
        `viso-bg-${color}-10`        
      )}
    >
      {value}
    </div>
  )
}

export default BackgroundRenderer